import ProjectWorkspace from './ProjectWorkspace';

export default ProjectWorkspace;
